import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { SlideContainer, ContentContainer } from '../../../../styles/LearnTab/slideBase.styles';
import { SlideImageLightboxModal } from './common/SlideImageLightbox.comp';
import { getEffectiveLayout, getSlideComponent } from './slideRegistry';

export * from '../../../../styles/LearnTab/slideBase.styles';
export * from '../../../../styles/LearnTab/activity.styles';
export * from '../../../../styles/LearnTab/rubric.styles';
export * from '../../../../styles/LearnTab/stepBlock.styles';
export * from '../../../../styles/LearnTab/outcomeCards.styles';

const SlideEngine = (props) => {
  const { slide } = props;
  const [lightboxImage, setLightboxImage] = useState(null);

  if (!slide) return null;

  const SlideLayoutComponent = getSlideComponent(slide);
  const effectiveLayout = getEffectiveLayout(slide);

  return (
    <>
      <SlideContainer>
        <ContentContainer>
          {SlideLayoutComponent ? (
            <SlideLayoutComponent
              {...props}
              onImageClick={setLightboxImage}
            />
          ) : (
            <Typography variant="body1" color="error">
              Unsupported slide layout: {effectiveLayout}
            </Typography>
          )}
        </ContentContainer>
      </SlideContainer>

      <SlideImageLightboxModal
        image={lightboxImage}
        onClose={() => setLightboxImage(null)}
      />
    </>
  );
};

export const SlideComponentV2 = SlideEngine;
export { SlideEngine };
export default SlideEngine;